import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

export const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100vh;
  overflow-y: hidden;
  min-width: 320px;
  p{
    color: #FFFFFF;
  }
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    overflow: auto;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: ${theme.spacing.stack.xxs};
    @media (min-width: 768px) and (max-width: 1170px) {
      padding: ${theme.spacing.stack.sm} ${theme.spacing.stack.xxl};
    }
    @media (min-width: 1171px) {
      padding: ${theme.spacing.stack.sm} ${theme.spacing.stack.xxxl};
    }
  `}
`

export const TextPassword = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.size.md};
    font-weight: ${theme.font.weight.semiBold};
    color: #FFFFFF;
    margin: ${theme.spacing.stack.xxs} 0 ${theme.spacing.stack.xxs} 0;
    max-width: 212px;
    line-height: ${theme.spacing.stack.sm};
    @media (min-width: 768px) and (max-width: 1170px) {
      max-width: 100%;
      margin: ${theme.spacing.stack.xl} 0 ${theme.spacing.stack.xs} 0;
    }
    @media (min-width: 1171px) {
      display: none;
    }
  `}
`

export const Logo = styled.img`
  ${({ theme }) => css`
    max-width: 200px;
    max-height: 75px;
    margin: 0 auto ${theme.spacing.stack.xxs};
    @media (min-width: 768px) {
      margin: 0 auto ${theme.spacing.stack.md};
    }
  `}
`

export const ContentForm = styled.div`
  ${({ theme }) => css`
    width: 100%;
    @media (min-width: 768px) {
      min-width: 522px;
      max-width: 522px;
    }
    @media (min-width: 1171px) {
      min-width: 418px;
      max-width: 418px;
    }
  `}
`

export const Form = styled.form`
  ${({ theme }) => css`
    height: 100%;
    width: 100%;
    margin-top: ${theme.spacing.stack.xxs};
    > button {
      margin-top: ${theme.spacing.stack.xxs};
    }
  `}
`

export const LegalPerson = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2rem;
  margin: 2rem 0;
`

export const TextObrigatory = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.size.xxs};
    color: ${theme.color.brand.primary.nth2};
    font-weight: ${theme.font.weight.semiBold};

    @media (min-width: 768px) {
      margin-top: ${theme.spacing.stack.xs};
      margin-bottom: ${theme.spacing.stack.xs};
      font-size: ${theme.font.size.sm};
      font-weight: ${theme.font.weight.bold};
    }
  `}
`

export const TextLegalPerson = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.size.xxs};
  `}
`

export const GroupFormDataCreator = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.stack.xxs};
    display: flex;
    flex-direction: column;
  `}
`

export const GroupFormAddressCreator = styled.div`
  display: flex;
  flex-direction: column;
`

export const PasswordRules = styled.div`
  ${({ theme }) => css``}
`

export const PasswordRule = styled.p`
  ${({ theme }) => css`
    color: #6c01a3;
    font-size: ${theme.font.size.sm};
    line-height: ${theme.spacing.stack.xxs};
    font-weight: ${theme.font.weight.semiBold};
  `}
`

export const SocialNetworkRow = styled.div`
  display: flex;
  gap: 6px;

  .select-container {
    width: 140px;
    min-width: 140px;
  }
`

export const customStyles = {
  clearIndicator: () => ({
    border: '1px solid blue'
  }),
  control: (provided: any) => ({
    ...provided,
    marginTop: '6px',
    display: 'flex',
    padding: '0 16px',
    background: '#080322',
    outline: 'none',
    border: '1px solid #CC92FE',
    boxShadow: '0 0 8px rgba(204, 146, 254, 0.4)',
    borderRadius: '16px',
    minHeight: '40px',
    height: '40px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#CC92FE',
      boxShadow: '0 0 12px rgba(204, 146, 254, 0.6)'
    }
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    margin: '0',
    background: 'transparent',
    height: '38px'
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: '38px',
    padding: 0,
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#CC92FE',
    '&:hover': {
      color: '#CC92FE'
    }
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#FFFFFF',
    fontSize: '16px',
    lineHeight: '38px',
    margin: 0
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#CC92FE'
  }),
  menu: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF',
    borderRadius: '8px',
    background: '#080322',
    border: '1px solid #CC92FE',
    boxShadow: '0 0 8px rgba(204, 146, 254, 0.4)',
    padding: '8px 0',
    marginTop: '8px'
  }),
  menuList: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF',
    borderRadius: '8px',
    background: '#080322',
    padding: '0'
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF',
    backgroundColor: state.isSelected ? '#CC92FE33' : 'transparent',
    padding: '8px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#CC92FE33'
    }
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF'
  })
}

export const Label = styled.p`
  ${({ theme }) => css`
    color: #39383a;
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.regular};
    line-height: 24px;
    margin-bottom: 0.5rem;
  `}
`

export const Error = styled.p`
  ${({ theme }) => css`
    color: #fc3e3e;
    font-size: ${theme.font.size.xxs};
    min-height: ${theme.spacing.stack.xxs};
  `}
`

export const ProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`

export const ProfileImageContainer = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 60px;
  margin-bottom: 8px;
`

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`

export const ProfilePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #CC92FE;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ImageInput = styled.input`
  display: none;
`

export const AddImageButton = styled.label`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: #CC92FE};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:hover {
    background-color: #CC92FE;
  }
`

export const SocialNetworksSection = styled.div`
  margin-bottom: 24px;
`

export const AddButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: #CC92FE;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:hover {
    background-color: #CC92FE;
  }
`

export const PlusIcon = styled.span`
  &:before {
    content: '+';
    color: white;
    font-size: 24px;
  }
`

export const UserIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #CC92FE;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E") center/contain no-repeat;
`

export const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #CC92FE;
  background-color: transparent;
  color: #CC92FE;
  font-size: 16px;
  resize: vertical;
  margin-bottom: 24px;
  border-radius: 16px;

  &::placeholder {
    color: #CC92FE;
  }

  &:focus {
    outline: none;
    border-color: #CC92FE;
  }
`

export const InterestsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`

export const InterestsTitle = styled.h2`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: ${theme.font.size.md};
    font-weight: ${theme.font.weight.semiBold};
    text-align: center;
    margin-bottom: 8px;
  `}
`

export const InterestsSubtitle = styled.p`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: ${theme.font.size.sm};
    text-align: center;
    margin-bottom: 24px;
  `}
`

export const InterestsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`

export const InterestButton = styled.button<{ selected?: boolean }>`
  ${({ theme, selected }) => css`
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid #CC92FE;
    background-color: ${selected ? '#CC92FE33' : 'transparent'};
    color: #FFFFFF;
    font-size: ${theme.font.size.sm};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #CC92FE33;
    }
  `}
`
